import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CreateInterfaceEnrollmentComponent } from './pages/home/create-interface-enrollment/create-interface-enrollment.component';
import { SmokeTestComponent } from './pages/home/smoke-test/smoke-test.component';
import { CommonModule } from '@angular/common'; 

const routes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full',
  },
  {
    path: 'home',
    loadChildren: () => import('./pages/home/home.module').then((h) => h.HomeModule),
  },
  {
    path: 'dashboard',
    loadChildren: () => import('./pages/dashboard/dashboard.module').then((d) => d.DashboardModule),
  },
  {
    path: 'activateUser/:activationkey',
    redirectTo: '/home/activateUser/:activationkey',
  },
 // { path: 'enrollmentform', redirectTo: 'createInterfaceEnrollment' },
  { path: 'smokeTest', redirectTo: '/home/smokeTest' },
  { path: 'smokeTest/:formid/:formkey', redirectTo: '/home/smokeTest/:formid/:formkey' },
  {
    path: 'imsWebService',
    redirectTo: '/home/imsWebService',
  },
  {
    path: 'cdcIISWebService',
    redirectTo: '/home/cdcIISWebService',
  },
  {
    path: 'managePassword',
    redirectTo: '/home/managePassword',
  },
  {
    path: 'activateFacility/:activationkey',
    redirectTo: '/home/activateFacility/:activationkey',
  },
  {
    path: 'activateCrushFtpAccount/:activationkey',
    redirectTo: '/home/activateCrushFtpAccount/:activationkey',
  }, {
    path: 'pla/:datasource/:totac',
    redirectTo: '/home/pla/:datasource/:totac'
  },

];

@NgModule({
  imports: [CommonModule,RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload', useHash: true })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
